/**
 * This function is used to get all the keys from local storage that match the given prefix.
 * @param prefix
 * @returns
 */
export function getLocalStorageKeysByPrefix(prefix: string) {
	const matchingKeys = [];
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (!key?.startsWith(prefix)) continue;
		matchingKeys.push(key);
	}
	return matchingKeys;
}
